import type { ReportColumn } from '../models/column.types'

import type { SelectOption, SelectOptionMeta, SelectOptionVisual } from '@/shared/ui/select'

type ReportColumnOptionSource = Pick<ReportColumn, 'field' | 'header'> &
  Partial<Pick<ReportColumn, 'disabled' | 'headerImage' | 'icon'>>

function columnVisual(column: ReportColumnOptionSource): SelectOptionVisual | undefined {
  const visual: SelectOptionVisual = {}
  if (column.icon) visual.icon = column.icon
  if (column.headerImage) visual.platform = column.headerImage
  return Object.keys(visual).length ? visual : undefined
}

/** The single projection used when a metric/dimension/report column enters a shared picker. */
export function toReportColumnOption(
  column: ReportColumnOptionSource,
  overrides: Partial<Omit<SelectOption<string>, 'value' | 'label'>> = {},
): SelectOption<string> {
  const visual = columnVisual(column)
  const inheritedMeta = overrides.meta
  const meta: SelectOptionMeta | undefined =
    visual || inheritedMeta ? { ...inheritedMeta, ...(visual ? { visual } : {}) } : undefined

  return {
    value: column.field,
    label: column.header,
    ...(column.disabled === undefined ? {} : { disabled: column.disabled }),
    ...overrides,
    ...(meta ? { meta } : {}),
  }
}

export function toReportColumnOptions(
  columns: readonly ReportColumnOptionSource[],
): SelectOption<string>[] {
  return columns.map((column) => toReportColumnOption(column))
}
